export const LAST_ACTIVITY_KEY = "fyrms.auth.lastActivity";
export const LAST_KEEP_ALIVE_KEY = "fyrms.auth.lastKeepAlive";
export const CONFIRMED_SIGN_OUT_KEY = "fyrms.auth.confirmedSignOut";

const fallbackTimestamps = new Map<string, number>();

export function readSessionTimestamp(
	key: string,
	now = Date.now()
): number | undefined {
	let rawValue: string | null;
	try {
		rawValue = localStorage.getItem(key);
	} catch {
		const fallbackTimestamp = fallbackTimestamps.get(key);
		return fallbackTimestamp === undefined
			? undefined
			: validateTimestamp(fallbackTimestamp, now);
	}

	if (rawValue === null) {
		return undefined;
	}

	return validateTimestamp(Number(rawValue), now);
}

export function writeSessionTimestamp(key: string, timestamp: number): void {
	const normalizedTimestamp = Math.max(0, Math.floor(timestamp));
	fallbackTimestamps.set(key, normalizedTimestamp);
	try {
		localStorage.setItem(key, `${normalizedTimestamp}`);
	} catch {
		// The in-memory value keeps automatic sign-out working in this tab.
	}
}

export function clearSessionTimestamp(key: string): void {
	fallbackTimestamps.delete(key);
	try {
		localStorage.removeItem(key);
	} catch {
		// There is nothing else to clear when browser storage is unavailable.
	}
}

export function confirmSignOut(): void {
	writeSessionTimestamp(CONFIRMED_SIGN_OUT_KEY, Date.now());
	redirectToSignIn();
}

export function isConfirmedSignOutEvent(event: StorageEvent): boolean {
	if (event.key !== CONFIRMED_SIGN_OUT_KEY || event.newValue === null) {
		return false;
	}
	return validateTimestamp(Number(event.newValue), Date.now()) !== undefined;
}

export function redirectToSignIn(): void {
	if (window.location.pathname !== "/sign-in") {
		window.location.replace("/sign-in");
	}
}

function validateTimestamp(timestamp: number, now: number): number | undefined {
	if (!Number.isFinite(timestamp) || timestamp < 0 || timestamp > now) {
		return undefined;
	}
	return timestamp;
}
